import type { ClassAttributes, ComponentType, HTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

type StyledOptInBackgroundBorder = ComponentType<
	{
		width?: number;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
>;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const OptInBackgroundBorder: StyledOptInBackgroundBorder = styled.div<{ width?: number }>({
	overflow: 'hidden',
	boxShadow: `${token('elevation.shadow.overlay')}`,

	borderRadius: token('radius.medium'),

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: (props) => (props.width ? `${props.width}px` : '450px'),
	paddingTop: token('space.025', '2px'),
	paddingRight: token('space.025', '2px'),
	paddingBottom: token('space.025', '2px'),
	paddingLeft: token('space.025', '2px'),
	position: 'relative',

	background: `conic-gradient(
          from 90deg,
          #1d7afc 10%,
          #8bdbe5 30%,
          #f8e6a0 50%,
          #8bdbe5 70%,
          #1d7afc 90%
        )`,
});

type StyledDiv = ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
>;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const OptInContainer: StyledDiv = styled.div({
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: token('elevation.surface.overlay'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ImageWrapper: StyledDiv = styled.div({
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: `${token('radius.small', '3px')} ${token('radius.small', '3px')} 0 0`,
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	img: {
		objectFit: 'cover',
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
		borderRadius: `${token('radius.small', '3px')} ${token('radius.small', '3px')} 0 0`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentContainer: StyledDiv = styled.div({
	display: 'flex',
	paddingTop: token('space.300', '24px'),
	paddingRight: token('space.300', '24px'),
	paddingBottom: token('space.300', '24px'),
	paddingLeft: token('space.300', '24px'),
	flexDirection: 'column',
	alignSelf: 'stretch',
	gap: token('space.100', '8px'),
	alignItems: 'flex-start',
});

type StyledDivProps = StyledDiv;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderWrapper: StyledDivProps = styled.div({
	font: token('font.heading.small'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyWrapper: StyledDivProps = styled.div({
	margin: '0',
	font: token('font.body'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ButtonContainer: StyledDivProps = styled.div({
	display: 'flex',
	width: '100%',
	marginTop: token('space.100', '8px'),
	justifyContent: 'flex-end',
	gap: token('space.050', '4px'),
});
